export default function () {
  $('.button').each((i, el) => {
    const $this = $(el);
    $this.html(`<span class="decor"></span><span>${$this.text()}</span>`);
  });
}



// WEBPACK FOOTER //
// ./scripts/elements/buttons.js